import { useEffect, useState } from "react";
import { NavBar } from "~/components/common/NavBar";
import { cn } from "~/lib/utils";
import { useAppStore } from "~/stores/app";

interface HeaderProps {
  variant?: "default" | "transparent";
  className?: string;
  navClassName?: string;
  bookingDisabled?: boolean;
  shopDisabled?: boolean;
}

export const Header = ({
  variant = "default",
  className,
  navClassName,
  bookingDisabled = false,
  shopDisabled = false,
}: HeaderProps = {}) => {
  const isTransparent = variant === "transparent";
  const [isScrolled, setIsScrolled] = useState(false);
  const { mobileMenuOpened } = useAppStore();

  useEffect(() => {
    if (!isTransparent) return;

    const handleScroll = () => {
      const scrollThreshold = 50;
      setIsScrolled(window.scrollY > scrollThreshold);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Controlla lo stato iniziale

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isTransparent]);

  return (
    <header
      className={cn(
        "fixed top-0 left-0 w-full z-[19] transition-all duration-500 ease-in-out",
        !mobileMenuOpened && !isTransparent && "bg-white-mute",
        !mobileMenuOpened &&
          isTransparent &&
          !isScrolled &&
          "bg-gradient-to-b from-black to-transparent",
        !mobileMenuOpened &&
          isTransparent &&
          isScrolled &&
          "bg-white shadow-md",
        className
      )}
    >
      <NavBar
        variant={variant}
        isScrolled={isScrolled}
        navClassName={navClassName}
        bookingDisabled={bookingDisabled}
        shopDisabled={shopDisabled}
      />
    </header>
  );
};
